import { SizeType } from 'antd/lib/config-provider/SizeContext';

export const generateHeight = (size: SizeType) => {
  if (size === 'large') {
    return '48px';
  }
  return '36px';
};
